export enum DocumentTypeEnum {
    FILE = 'file',
    LINK = 'link',
}
